"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCaret = exports.Caret = void 0;
const react_1 = __importDefault(require("react"));
const isString_1 = __importDefault(require("lodash/isString"));
const styled_components_1 = __importDefault(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const types_1 = require("./types");
const getCaretSize = ({ size }) => {
    if (!size) {
        size = types_1.CaretSize.Medium;
    }
    if ((0, monera_app_core_1.getValuesOfStringEnum)(types_1.CaretSize).includes(size)) {
        switch (size) {
            case types_1.CaretSize.Small:
                return ['0.5em', '0.55em'];
            case types_1.CaretSize.Medium:
            default:
                return ['1em', '.55em'];
        }
    }
    else if ((0, isString_1.default)(size)) {
        return [size, size];
    }
    return size;
};
const Caret = (props) => {
    const [width, height] = getCaretSize(props);
    return (react_1.default.createElement("svg", { width: width, height: height, viewBox: "0 0 17 10", version: "1.1", className: props.className },
        react_1.default.createElement("title", null, "caret"),
        react_1.default.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { transform: "translate(-14.000000, -2668.000000)", fill: props.linkColor || props.theme.palettes.font.link },
                react_1.default.createElement("g", { transform: "translate(0.000000, 2373.000000)" },
                    react_1.default.createElement("g", { transform: "translate(0.000000, 40.000000)" },
                        react_1.default.createElement("g", { transform: "translate(14.000000, 248.000000)" },
                            react_1.default.createElement("polygon", { points: "-7.10542736e-14 8.42647162 7.08680696 15.5721895 7.08531345 15.5736957 8.49952702 17 8.50118647 16.9983264 8.50284632 17 9.91739181 15.5736957 9.91556598 15.5718547 16.999338 8.42752065 15.5851244 7.00121639 8.50118647 14.1457178 1.41437951 7 -7.01660952e-14 8.42647162" }))))))));
};
exports.Caret = Caret;
exports.StyledCaret = (0, styled_components_1.default)(exports.Caret).attrs((props) => ({
    theme: props.theme
})) `
  margin-right: 5px;
  ${({ rotation }) => rotation && `transform: rotate(${rotation})`};
`;
